<div>
    <input
        auto-complete
        [source]="contacts"
        [list-formatter]="formatContact"
        [value-formatter]="formatContact"
        [accept-user-input]="false"
        [min-chars]="2"
        name="contact"
        class="form-control input-sm"
        required
        autocomplete="off"
        (valueChanged)="onContactSelected($event)">
</div>

<button type="button" class="btn btn-default btn-sm" aria-hidden="true" (click)="showModalAddContact(addContactModal)">
    <i class="fa fa-plus" aria-hidden="true"></i>
</button>

<ng-template #addContactModal>
    <div class="window-close" (click)="closeCreateContactModal()"><i class="fa fa-window-close" aria-hidden="true"></i>
    </div>
    <contacts-detail (getContact)="getCreatedContact($event)" [contact]="createdContact" [company]="company"
                     contactType="createInModal"></contacts-detail>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/contact-edition/contact-edition.component.html